import moment from 'moment';
import { fromJS, List } from 'immutable';
import { createReducer } from 'utils/redux';
import initialState from 'modules/Notifications/redux/initialState';
import * as actionTypes from 'modules/Notifications/redux/actionTypes';

const onShowSidebar = (state) => state.set('sidebarIsVisible', true);

const onHideSidebar = (state) => state.set('sidebarIsVisible', false);

const onGetNotifications = (state) =>
  state.setIn(['notifications', 'loading'], true).setIn(['notifications', 'error'], null);

const onGetNotificationsSuccess = (
  state,
  {
    payload: {
      data: { notifications, unreadCount, totalCount },
      skipHasNextPageUpdate,
    },
  },
) =>
  state
    .setIn(['notifications', 'data'], fromJS(notifications))
    .setIn(['notifications', 'unreadCount'], unreadCount)
    .setIn(
      ['notifications', 'hasNextPage'],
      !skipHasNextPageUpdate
        ? totalCount > notifications.length
        : state.getIn(['notifications', 'hasNextPage']),
    )
    .setIn(['notifications', 'loading'], false);

const onGetNotificationsError = (state, { payload }) => state.set('error', fromJS(payload));

const onReadNotification = (state, { payload: { id } }) => {
  const notificationIdx = state
    .getIn(['notifications', 'data'])
    .findIndex((item) => item.get('id') === id);

  const unreadCount = state.getIn(['notifications', 'unreadCount']);

  return state
    .setIn(
      ['notifications', 'data', notificationIdx, 'readingDate'],
      moment().format('YYYY-MM-DD HH:mm:ss'),
    )
    .setIn(['notifications', 'unreadCount'], unreadCount > 0 ? unreadCount - 1 : 0);
};

const onRemoveNotification = (state, { payload: { id } }) => {
  const found = state.getIn(['notifications', 'data']).find((item) => item.get('id') === id);
  const notifications = state
    .getIn(['notifications', 'data'])
    .filter((item) => item.get('id') !== id);

  let newState = state.setIn(['notifications', 'data'], notifications);
  const unreadCount = state.getIn(['notifications', 'unreadCount']);

  if (found && found.get('readingDate') === null) {
    newState = newState.setIn(
      ['notifications', 'unreadCount'],
      unreadCount > 0 ? unreadCount - 1 : 0,
    );
  }

  return newState;
};

const onReadAllNotifications = (state) =>
  state
    .setIn(
      ['notifications', 'data'],
      state
        .getIn(['notifications', 'data'])
        .map((n) => n.set('readingDate', moment().format('YYYY-MM-DD HH:mm:ss'))),
    )
    .setIn(['notifications', 'unreadCount'], 0);
const onRemoveAllNotifications = (state) =>
  state
    .setIn(['notifications', 'data'], List())
    .setIn(['notifications', 'unreadCount'], 0)
    .setIn(['notifications', 'hasNextPage'], false);

const onFetchMore = (state) =>
  state.setIn(['notifications', 'loadingMore'], true).setIn(['notifications', 'error'], null);

const onFetchMoreSuccess = (state, { payload: { notifications, unreadCount, totalCount } }) => {
  const mergedNotifications = state.getIn(['notifications', 'data']).concat(fromJS(notifications));

  return state
    .setIn(['notifications', 'data'], mergedNotifications)
    .setIn(['notifications', 'unreadCount'], unreadCount)
    .setIn(['notifications', 'hasNextPage'], totalCount > mergedNotifications.size)
    .setIn(['notifications', 'loadingMore'], false);
};

const onFetchMoreError = (state, { payload }) => state.set('error', fromJS(payload));

const onQueueToast = (state, { payload }) => state.set('queue', state.get('queue').push(payload));

const onClearQueue = (state) => state.set('queue', List());

const onSetUnreadCounter = (state, { payload }) =>
  state.setIn(['notifications', 'unreadCount'], payload);

const onShowModal = (state, { payload: { title, content } }) => {
  return state
    .set('modalIsVisible', true)
    .setIn(['modal', 'title'], title)
    .setIn(['modal', 'content'], content);
};

const onCloseModal = (state) =>
  state.set('modalIsVisible', false).setIn(['modal', 'title'], '').setIn(['modal', 'content'], '');

export default createReducer(initialState, {
  [actionTypes.SHOW_SIDEBAR]: onShowSidebar,
  [actionTypes.HIDE_SIDEBAR]: onHideSidebar,
  [actionTypes.NOTIFICATIONS]: onGetNotifications,
  [actionTypes.NOTIFICATIONS_SUCCESS]: onGetNotificationsSuccess,
  [actionTypes.NOTIFICATIONS_FAILURE]: onGetNotificationsError,
  [actionTypes.NOTIFICATIONS_READ]: onReadNotification,
  [actionTypes.NOTIFICATIONS_REMOVE]: onRemoveNotification,
  [actionTypes.NOTIFICATIONS_READ_ALL]: onReadAllNotifications,
  [actionTypes.NOTIFICATIONS_REMOVE_ALL]: onRemoveAllNotifications,
  [actionTypes.NOTIFICATIONS_MORE]: onFetchMore,
  [actionTypes.NOTIFICATIONS_MORE_SUCCESS]: onFetchMoreSuccess,
  [actionTypes.NOTIFICATIONS_MORE_FAILURE]: onFetchMoreError,
  [actionTypes.QUEUE_TOAST]: onQueueToast,
  [actionTypes.CLEAR_TOASTS_QUEUE]: onClearQueue,
  [actionTypes.SET_UNREAD_COUNTER]: onSetUnreadCounter,
  [actionTypes.SHOW_MODAL]: onShowModal,
  [actionTypes.CLOSE_MODAL]: onCloseModal,
});
